import React, { useEffect, useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { DRAWER_WIDTH, COLLAPSED_WIDTH } from "./layoutConstants";
import { Outlet } from "react-router-dom";
import TopLoadingBar from "../components/ui/TopLoadingBar";
import PageTransition from "../components/ui/PageTransition";
import "../theme/portalTokens.css";
import "../theme/portalBrand.css";
import "../theme/portalTable.css";

export default function Layout() {
  const isMobile = useMediaQuery("(max-width:899px)");

  // mobile par sidebar default closed, desktop par open
  const [open, setOpen] = useState(!isMobile);

  useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);

  const left = open ? DRAWER_WIDTH : COLLAPSED_WIDTH;

  const handleToggleSidebar = () => {
    setOpen((prev) => !prev);
  };

  const handleCloseSidebar = () => {
    if (isMobile) {
      setOpen(false);
    }
  };

  return (
    // Page background (soft pink satin waves) comes from theme/portalBrand.css
    // `.portal-theme` -- no MUI sx backgroundColor here, which would win over it.
    <Box className="portal-theme" sx={{ display: "flex", minHeight: "100vh" }}>
      <TopLoadingBar />
      <Sidebar isOpen={open} onClose={handleCloseSidebar} />

      <Header
        isSidebarOpen={open}
        onToggleSidebar={handleToggleSidebar}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: {
            xs: "100%",
            md: `calc(100% - ${left}px)`,
          },
          pt: {
            xs: "72px",
            md: "104px",
          },
          px: {
            xs: 1.5,
            sm: 2,
            md: 3,
          },
          pb: 3,
          minHeight: "100vh",
          overflowX: "hidden",
          backgroundColor: "transparent",
          transition: (theme) =>
            theme.transitions.create(["width", "margin-left"], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.shorter,
            }),
        }}
      >
        <PageTransition>
          <Outlet />
        </PageTransition>
      </Box>
    </Box>
  );
}